import React from 'react';
import Select from '../Select/Select';
import { DOCUMENT_TYPES_OPTIONS } from '../../constants';

const SelectDocumentType = ({ ...props }) => {
  return <Select options={DOCUMENT_TYPES_OPTIONS} label={'Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectDocumentType;
